/* eslint-disable camelcase */
// import api from '../../services/service_item'
import apiSTC from '../../services/stadard_cost'
import apiItem from '../../services/service_item.js'
import apiMain from '../../services/service'
import Swal from 'sweetalert2'
var moment = require('moment')
export default {
  data () {
    return {
      title: 'จัดการสินค้า',
      search: '',
      currentPage: 1,
      items_perpage: 10,
      active: 1,
      modal_active: false,
      modal_data: {
        'id': 0,
        'item_id': 0,
        'item_code': '',
        'item_name': '',
        'cost': 0,
        'unit_code': '',
        'used_time': moment(new Date())
      },
      modal_title: '',
      data_list: [],
      menu_active: 0,
      menus: [
        { name: 'menu1' },
        { name: 'menu2' },
        { name: 'menu3' },
        { name: 'menu4' },
        { name: 'menu5' }
      ],
      group: [],
      data_list_group: [],
      branch: 'all',
      modal_data_item: {
        'id': 0,
        'item_id': 0,
        'item_code': '',
        'item_name': '',
        'cost': 0,
        'unit_code': '',
        'mis_uuid': '',
        'used_time': moment(new Date())
      },
      unit: [],
      data_item: [],
      modal_item_active: false
    }
  },
  computed: {
    filterData: function () {
      let text = this.search.trim()
      this.currentPage = 1
      return this.data_list.filter(items => {
        return (
          items.item_code.indexOf(text) > -1 || items.item_name.indexOf(text) > -1
        )
      })
    },
    paginate: function () {
      this.totalItem = this.filterData.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.filterData.slice(index, index + this.items_perpage)
    }
  },
  methods: {
    moment,
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    filterOption1 (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    selectText (val) {
      document.getElementById(val).select()
    },
    handleChangeItem (value, name) {
      console.log(`selected ${value}`)
      console.log(`selected ${name}`)
      this.modal_data_item.item_id = value
      this.modal_data_item.item_name = name
      this.getItem(value)
    },
    addUnit (val) {
      let index = this.unit.find(x => x.unit_code === val)
      if (index == null) {
      } else {
        this.modal_data_item.unit_code = index.unit_code
      }
      // this.modal_data.unit_code = val
      // console.log(this.modal_data.unit_code)
    },
    getBill (val) {
      let url, token
      if (this.branch === 'all') {
        url = sessionStorage.Url
        token = sessionStorage.token
      } else {
        url = this.branch.dyn_address + '/'
        token = this.branch.access_token
      }
      this.$store.commit('Loading')
      apiSTC.standartCostSearchID(
        url,
        // apiMain.callMisApi(
        //   url + 'product/v1/standard/cost/id',
        {
          headers: {
            'Access-Token': token
          }
        },
        { 'id': parseInt(val.id) },
        result => {
          if (result.response === 'success') {
            this.modal_data_item = result.data
            this.modal_data_item.used_time = moment(result.data.used_time)
            this.modal_item_active = true
            this.getItem(result.data.item_id)
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลไม่ได้',
              description: result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูลสินค้า ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    addItem () {
      let temp_data = {
        'id': 0,
        'item_id': 0,
        'item_code': '',
        'item_name': '',
        'cost': 0,
        'unit_code': '',
        'used_time': moment(new Date())
      }
      this.modal_data_item = temp_data
      console.log(JSON.stringify(this.modal_data_item))
      this.modal_item_active = true
    },
    close_modal_item () {
      this.modal_data_item.used_time = null
      this.modal_item_active = false
    },
    testdata () {
      console.log(this.modal_data_item)
    },
    getItem (val) {
      let url, token
      if (this.branch === 'all') {
        url = sessionStorage.Url + 'mis/v1/product/item/id'
        token = sessionStorage.token
      } else {
        url = this.branch.dyn_address + '/' + 'product/v1/item/id'
        token = this.branch.access_token
      }
      // apiMain.callMisApi(
      //   url,
      apiItem.itemByIdMe(
        url,
        {
          headers: {
            'Access-Token': token
          }
        },
        { 'id': parseInt(val) },
        result => {
          if (result.response === 'success') {
            console.log(JSON.stringify(result))
            this.unit = result.data.bar_data
            this.modal_data_item.price = result.data.bar_data[0].price_1
            this.modal_data_item.unit_id = result.data.stk_unit_id
            this.modal_data_item.unit_code = result.data.stk_unit_code
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลไม่ได้',
              description: result.message
            })
          }
          this.$store.state.Loading = false
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูลสินค้า ' + JSON.stringify(error))
          this.$store.state.Loading = false
        }
      )
    },
    confirmModel () {
      if (this.branch === 'all') {
        if (this.modal_data_item.id !== 0) {
          console.log('new all')
          this.updateAll()
        } else {
          console.log('edit all')
          this.createAll()
        }
      } else {
        if (this.modal_data_item.id !== 0) {
          console.log('new')
          this.updateBill()
        } else {
          console.log('edit')
          this.createBill()
        }
      }
      this.modal_item_active = false
      console.log(this.modal_data_item)
    },
    createBill () {
      this.modal_data_item.used_time = this.dateFormatAndTimeDat(this.modal_data_item.used_time)
      this.$store.commit('Loading')
      apiMain.callMisApi(
        this.branch.dyn_address + '/' + 'product/v1/standard/cost/new',
        {
          headers: {
            'client-token': this.branch.access_token,
            'access-token': sessionStorage.token
          }
        },
        this.modal_data_item,
        result => {
          if (result.response === 'success') {
            Swal.fire({
              icon: 'success',
              title: 'Your work has been saved',
              showConfirmButton: false,
              timer: 2500
            }).then(() => {
              this.modal_data_item.used_time = null
              this.getListAll()
            })
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลไม่ได้',
              description: result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูลสินค้า ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    updateBill () {
      this.$store.commit('Loading')
      this.modal_data_item.used_time = this.dateFormatAndTimeDat(this.modal_data_item.used_time)
      apiMain.callMisApi(
        this.branch.dyn_address + '/' + 'product/v1/standard/cost/update',
        {
          headers: {
            'client-token': this.branch.access_token,
            'access-token': sessionStorage.token
          }
        },
        this.modal_data_item,
        result => {
          if (result.response === 'success') {
            Swal.fire({
              icon: 'success',
              title: 'Your work has been saved',
              showConfirmButton: false,
              timer: 2500
            }).then(() => {
              this.modal_data_item.used_time = null
              this.getListAll()
            })
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลไม่ได้',
              description: result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูลสินค้า ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    createAll () {
      console.log(this.$store.state.branch_list)
      this.modal_data_item.used_time = this.dateFormatAndTimeDat(this.modal_data_item.used_time)
      this.$store.state.Loading = true

      // cloud //
      apiSTC.getListMe(
        sessionStorage.Url + 'mis/v1/standard/cost/new',
        {
          headers: {
            'Access-Token': sessionStorage.token
          }
        },
        this.modal_data_item,
        result => {
          if (result.response === 'success') {
            this.modal_data_item.mis_uuid = result.data.mis_uuid
            setTimeout(() => {
              this.$store.state.branch_list.forEach(element => {
                // apiSTC.stanDardCostNew(
                apiMain.callMisApi(
                  element.dyn_address + '/' + 'product/v1/standard/cost/new',
                  {
                    headers: {
                      'client-token': element.access_token,
                      'access-token': sessionStorage.token
                    }
                  },
                  this.modal_data_item,
                  result => {
                    if (result.response === 'success') {

                    } else {
                      this.$notification['warning']({
                        message: 'ดึงข้อมูลไม่ได้',
                        description: result.message + ' : ' + element.dyn_address
                      })
                    }
                  },
                  error => {
                    this.$notification['warning']({
                      message: 'ไม่สามารถเข้าถึงข้อมูล',
                      description: JSON.stringify(error)
                    })
                  }
                )
              })
            }, 300)
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูลสินค้า ' + JSON.stringify(error))
        }
      )
      // loop //

      setTimeout(() => {
        this.getListAll()
        this.$store.state.Loading = false
      }, 1000)
    },
    updateAll () {
      console.log(this.$store.state.branch_list)
      this.modal_data_item.used_time = this.dateFormatAndTimeDat(this.modal_data_item.used_time)
      this.$store.state.Loading = true

      // cloud //
      apiSTC.getListMe(
        sessionStorage.Url + 'mis/v1/standard/cost/update',
        {
          headers: {
            'Access-Token': sessionStorage.token
          }
        },
        this.modal_data_item,
        result => {
          if (result.response === 'success') {

          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูลสินค้า ' + JSON.stringify(error))
        }
      )
      // loop //

      this.$store.state.branch_list.forEach(element => {
        // apiSTC.stanDardCostUpdate(
        apiMain.callMisApi(
          element.dyn_address + '/' + 'product/v1/standard/cost/update',
          {
            headers: {
              'client-token': element.access_token,
              'access-token': sessionStorage.token
            }
          },
          this.modal_data_item,
          result => {
            if (result.response === 'success') {

            } else {
              this.$notification['warning']({
                message: 'ดึงข้อมูลไม่ได้',
                description: result.message + ' : ' + element.dyn_address
              })
            }
          },
          error => {
            this.$notification['warning']({
              message: 'ไม่สามารถเข้าถึงข้อมู',
              description: JSON.stringify(error)
            })
          }
        )
      })
      setTimeout(() => {
        this.getListAll()
        this.$store.state.Loading = false
      }, 2000)
    },
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    onChange (pageNumber) {
      this.active = pageNumber
    },
    goToPage (path, id) {
      this.$store.state.historyPage = this.$route.path
      this.$router.push({ name: path, params: { branch_id: this.branch.id, id: id } })
    },
    doing () {
      alert('รอดำเนินการ')
    },
    select (address) {
      this.modal_data.sub_district = address.district
      this.modal_data.district = address.amphoe
      this.modal_data.province = address.province
      this.modal_data.zipcode = address.zipcode
    },
    close_modal () {
      this.modal_active = false
      this.modal_data = {
        name: '',
        credit_day: 0,
        debt_balance: 0,
        telephone: '',
        address: '',
        sub_district: '',
        district: '',
        province: '',
        zipcode: '',
        active_status: ''
      }
    },
    getProductAll () {
      let url, token
      if (this.branch === 'all') {
        url = sessionStorage.Url + 'mis/v1/product/item'
        token = sessionStorage.token
      } else {
        url = this.branch.dyn_address + '/' + 'product/v1/item'
        token = this.branch.access_token
      }
      apiItem.listProductByConfig(
        url,
        {
          headers: {
            'Access-Token': token
          }
        },
        {},
        result => {
          this.$store.state.isLoading = false
          if (result.response === 'success') {
            // console.log(result)
            this.data_item = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลลูกหนี้',
              description:
                result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    getListAll () {
      let url, token
      if (this.branch === 'all') {
        url = sessionStorage.Url
        token = sessionStorage.token
      } else {
        url = this.branch.dyn_address + '/'
        token = this.branch.access_token
      }
      this.$store.state.isLoading = true
      apiSTC.getListStandard(url,
        {
          headers: {
            'Access-Token': token
          }
        },
        {'keyword': ''},
        result => {
          // console.log(result)
          this.$store.state.isLoading = false
          if (result.response === 'success') {
            this.data_list = result.data
          } else {
            this.data_list = []
            this.alert_msg('warning', 'ดึงข้อมูลสินค้า',
              result.message
            )
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.data_list = []
          this.$store.state.isLoading = false
          console.log(error)
          this.alert_msg('error', 'ไม่สามารถเข้าถึงข้อมูลได้', 'เชื่อมต่อสาขาไม่ได้')
        }
      )
    }
    // editItem (val) {
    //   console.log(val.id)
    //   this.goToPage('manageitem', val.id)
    // }
  },
  mounted () {
    this.checkUser()
    this.getBranch()
    setTimeout(() => {
      // this.branch = this.$store.state.branch_list[0]
      this.getListAll()
      this.getProductAll()
    }, 500)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/standard_list.js